/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Share_Learnmorepublic2Inputs */

const zh_share_learnmorepublic2 = /** @type {(inputs: Share_Learnmorepublic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`公开：任何人都可以搜索和访问此内容。`)
};

const en_share_learnmorepublic2 = /** @type {(inputs: Share_Learnmorepublic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Public: Anyone on the web can find and access this content.`)
};

const es_share_learnmorepublic2 = /** @type {(inputs: Share_Learnmorepublic2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Público: Cualquiera en la web puede encontrar y acceder a este contenido.`)
};

/**
* | output |
* | --- |
* | "Public: Anyone on the web can find and access this content." |
*
* @param {Share_Learnmorepublic2Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const share_learnmorepublic2 = /** @type {((inputs?: Share_Learnmorepublic2Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Share_Learnmorepublic2Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_share_learnmorepublic2(inputs)
	if (locale === "en") return en_share_learnmorepublic2(inputs)
	return es_share_learnmorepublic2(inputs)
});
export { share_learnmorepublic2 as "share_learnMorePublic" }